export const langLabels = {
  zhHans: "简体中文",
  zhHant: "繁體中文",
  en: "English",
  ms: "Bahasa Melayu",
};

export const languageLabels = {
  zhHans: {
    zhHans: "简体中文",
    zhHant: "繁体中文",
    en: "英文",
    ms: "马来文",
  },
  zhHant: {
    zhHans: "簡體中文",
    zhHant: "繁體中文",
    en: "英文",
    ms: "馬來文",
  },
  en: {
    zhHans: "Simplified Chinese",
    zhHant: "Traditional Chinese",
    en: "English",
    ms: "Malay",
  },
  ms: {
    zhHans: "Cina Ringkas",
    zhHant: "Cina Tradisional",
    en: "Inggeris",
    ms: "Bahasa Melayu",
  },
};